import { tool as toolAddCharacter } from './tool.addCharacter';
import { tool as toolAddModel } from './tool.addModel';
import { tool as toolClearScene } from './tool.clearScene';
import { tool as toolDownload } from './tool.download';
import { tool as toolDownloadImage } from './tool.downloadImage';
import { tool as toolEndSession } from './tool.endSession';
import { tool as toolEnvironment } from './tool.environment';
import { tool as toolPopulateScene } from './tool.populateScene';
import { tool as toolRandomize } from './tool.randomize';
import { tool as toolSceneIntructions } from './tool.sceneIntructions';
import { tool as toolStartScene } from './tool.sceneStart';
import { tool as toolSoda } from './tool.soda';
import { tool as toolStyleTransfer } from './tool.styleTransfer';
import { tool as toolSwitchMode } from './tool.switchMode';
import { tool as toolTextTaco } from './tool.textaco';

export const tools = [
  toolAddModel, //
  toolDownload,
  toolDownloadImage,
  toolStartScene,
  toolEndSession,
  toolEnvironment,
  toolSceneIntructions,
  toolRandomize,
  toolSoda,
  toolAddCharacter,
  toolStyleTransfer,
  toolTextTaco,
  toolClearScene,
  toolSwitchMode,
  toolPopulateScene,
];

export { styleTransfer as styleTransferStyles } from './data/data.styleTransfer';
